import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSteemComponent } from './simple-icons-steem.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSteemComponent ],
    exports:      [ SimpleIconsSteemComponent ],
    bootstrap:    []
})
export class SimpleIconsSteemModule {}
